'use client'
import { useWindowDimensions } from '@/hooks/client/use-window-dimensions'

// Must match the `desktop-xl` screen in tailwind.config.mjs. From this width
// the band runs wider than the bar's 1440px column (LauncherPanel), so the
// tree sits left of the logo and the grid leads with four cards instead of
// three (SheetCardGrid). Keep this constant and the Tailwind screen in sync.
const WIDE_LAUNCHER_MIN_WIDTH = 1640

/** True when the desktop band is in its wide, four-up presentation. */
export const useIsWideLauncher = (): boolean => {
  const { width } = useWindowDimensions(true)
  return width !== null && width >= WIDE_LAUNCHER_MIN_WIDTH
}
